import * as React from "react";
const ArrowTopRight = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.1268 6.87317V7.87302L15.4196 7.87372L6.87354 16.4198L7.58064 17.1269L16.1267 8.58083V12.873H17.1266V6.87388L11.1268 6.87317Z", clipRule: "evenodd" }));
ArrowTopRight.displayName = "ArrowTopRight";
var ArrowTopRight_default = ArrowTopRight;
export {
  ArrowTopRight_default as default
};
